import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            深度吃瓜观察
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            行业分析、趋势解读与幕后深度，不止于吃瓜更懂娱乐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card) => (
            <div
              key={card.id}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-full aspect-[4/3] bg-background-100 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </div>
          ))}

          <div
            className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
          >
            <div className="w-full aspect-[4/3] bg-background-100 overflow-hidden">
              <img
                src={cards[6].image}
                alt={cards[6].title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {cards[6].tag}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 line-clamp-2">
                {cards[6].title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cards[6].description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}